import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { PromoComponent } from 'src/app/components/general/promo/promo.component';
import { AccountPackageService } from '../account/account-package.service';

import { VoucherService } from '../subscription/voucher.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class PromoService implements OnInit, OnDestroy {

  private modal: HTMLIonModalElement;

  constructor(
    private platform: Platform,
    private modalController: ModalController,
    private accountPackageService: AccountPackageService,
    private voucherService: VoucherService,
    private storageService: StorageService,
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  async checkPromoBanner() {
    await this.platform.ready();
    const specialPromoId = this.getSpecialPromoVoucher();
    if (specialPromoId) {
      const storage = await this.storageService.get(specialPromoId);
      if (!storage) {
        if (this.accountPackageService.accountId) {
          if (!this.accountPackageService.accountPackage?.accountStatus?.premium) {
            this.presentPromoModal(false, specialPromoId);
          }
        } else {
          this.presentPromoModal(false, specialPromoId);
        }
      }
    }
  }

  getSpecialPromoVoucher() {
    return this.voucherService.getSpecialPromoVoucher(new Date());
  }

  async presentPromoModal(redeemMode: boolean, voucherId?: string) {
    if (!this.modal) {
      this.modal = await this.modalController.create({
        component: PromoComponent,
        cssClass: 'modal-transparent',
        backdropDismiss: true,
        componentProps: {
          redeemMode,
          voucherId,
        }
      });
      this.modal.present();
      this.modal.onDidDismiss().then(() => {
        this.storageService.set(redeemMode ? 'SMS_PROMO_REDEEM' : voucherId, 'true');
        this.modal = null;
      });
    }
  }
}
